//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCookie, getUrlParam, setCookie } from './common/js/until'
export default {
  name: 'App',
  data () {
    return {
      isPc: false,
      year: new Date().getFullYear()
    }
  },
  mounted () {
    if (!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      if (window.location.pathname.indexOf('/live') < 0) {
        this.isPc = true
      }
      if (window.location.pathname.indexOf('/windows') > -1 || window.location.pathname.indexOf('/recordLogin') > -1) {
        this.isPc = false
      }
    }
    let clfrom = getUrlParam('clfrom')
    if (clfrom) {
      if (clfrom == 'dx' && getCookie('clfrom')) {
      } else {
        setCookie('clfrom', clfrom, 7)
      }
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: '橙啦'
    // all titles will be injected into this template
    //      titleTemplate: '%s | My Awesome Webapp',
  }
}



// WEBPACK FOOTER //
// ./src/App.vue